export default "__VITE_ASSET__DXt$Q$Zu__"